import { useEffect } from 'react';
import { useMapController } from '../map/MapShell.js';
import { useFollowStore } from './followStore.js';
import { startFollowMetrics, stopFollowMetrics } from './followMetrics.js';

/**
 * Mounted on the Naviger screen while a route is being followed: draws the
 * overlay and runs the metrics/auto-advance service (spec 05).
 */
export function FollowRouteLayer(): null {
  const controller = useMapController();
  const route = useFollowStore((s) => s.route);
  const activeLeg = useFollowStore((s) => s.activeLeg);

  useEffect(() => {
    startFollowMetrics();
    return () => stopFollowMetrics();
  }, []);

  useEffect(() => {
    if (!controller) return;
    if (route) {
      controller.drawFollowRoute(route.waypoints, activeLeg);
      return () => controller.clearFollowRoute();
    }
    return undefined;
  }, [controller, route, activeLeg]);

  return null;
}
